<template>
  <section 
    :id="sectionId"
    :class="[{'isEditing': isEditing, 'isSelected': isSectionSelected || isSectionHover}]"
    @mouseenter="$store.dispatch('setSectionHover', sectionId)"
    @mouseleave="$store.dispatch('setSectionHover', '')"
    @click="handleShowSectionToEdit"
  >
    <slot></slot>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'SectionContainer',
  props: {
    sectionId: { type: String },
  },
  computed: {
    ...mapGetters(['navbar', 'sectionHover']),

    isEditing () {
      return this.$route.name === 'BodyEdit'
    },

    isSectionSelected () {
      return this.$route.name === 'BodyEdit' && this.navbar.open && this.navbar.sectionId === this.sectionId
    },

    isSectionHover () {
      return this.$route.name === 'BodyEdit' && this.navbar.open && this.sectionHover === this.sectionId
    }
  },

  data: () => ({}),

  methods: {
    handleShowSectionToEdit () {
      if (this.$route.name !== 'BodyEdit') return
      
      if (this.navbar.sectionId !== this.sectionId) {
        this.$store.dispatch("setNav", { open: true, sectionId: this.sectionId })
        setTimeout(() => { this.$vuetify.goTo(`#${this.sectionId}`) }, 100)
      }
    }
  }
}
</script>

<style scoped>
.isEditing, .isSelected {
  position: relative;
}

.isEditing:hover::before, .isSelected::before{
  content: "";
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 3px solid #7BCDFE;
  z-index: 1; 
}

.isSelected::before {
  border: 3px solid #7BCDFE;
}
</style>

